import { attr } from '@square/dashboard-data/utils/ember-model-stubs';
import BaseAddonsSettings from './base-addons-settings';
import Money from '../money';
export default BaseAddonsSettings.extend({
  usesOpenTicketsMenuAsHomeScreen: attr(Boolean, {
    defaultValue: false
  }),
  usesPredefinedTickets: attr(Boolean, {
    defaultValue: false
  }),
  sendsDailyDeletionEmail: attr(Boolean, {
    defaultValue: false
  }),
  isPreAuthEnabled: attr(Boolean, {
    defaultValue: false
  }),
  isSendAndStayEnabled: attr(Boolean, {
    defaultValue: false
  }),
  minimumPreAuthAmount: attr(Money, {
    defaultValue() {
      return Money.create({
        amount: 1500,
        currencyCode: 'USD'
      });
    }
  })
});